jQuery('document').ready(function($){
	function toggleMenu(open) {
		$('#site-header').toggleClass('navOpen', open)
		$('body').toggleClass('menuOpen', open)
	}

	$('.mMenu').on('click', function(){
		toggleMenu(!$('#site-header').hasClass('navOpen'))
	});

	$('.menu-overlay').on('click', function(){
		toggleMenu(false)
	});
});

jQuery(document).ready(function ($) {
    $('.siteMenu .menu-item-has-children').on('click', function(event) {
        $target = $(event.target);
        $target.toggleClass('open');
    });
    $('.siteMenu .sub-menu .menu-item-has-children').on('click', function(event) {
        $target = $(event.target);
        $target.toggleClass('open');
    });
});